/**=========================================================
 * Module: app-analysis.js
 * Handles analysis
 =========================================================*/

App.directive('appAnalysis', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/analysis.html',
      restrict: 'E',
      replace: true,
      scope: {
          model: '=model',
          project: '=project',
          cls: '@cls',
          title: '=paneltitle'
      }
  };

});
